import classNames from 'classnames'

const Button = ({
  active,
  uppercase,
  children,
  onClick,
  className,
  responsive,
  disabled,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        disabled && 'opacity-50 cursor-default',
        active ? 'bg-cyanBlue text-black ' : 'text-white ',
        !disabled && active
          ? 'hover:bg-transparent hover:text-cyanBlue'
          : !disabled && !active && 'hover:bg-cyanBlue hover:text-black ',
        uppercase ? 'uppercase' : '',
        !responsive && 'px-10',

        className,
        [
          'cursor-pointer py-1.5 2xl:py-2 rounded border border-cyanBlue transition-all duration-300',
        ],
      )}
    >
      {children}
    </button>
  )
}

export default Button
